export default __webpack_public_path__ + "static/media/secondCarouselImage.e6a6cbaf.png";